
<template>
<div class="content">

  <pre>
    file1 = {{ file1 }}
    file2 = {{ file2 }}
    sitem = {{ sitem }}
  </pre>
  이름 : <input type="text" v-model="sitem.name" />
  첨부파일 :
    <i-fileupload
      ref="file1"
      v-model="file1"
      :required=false
      kind="vie_free">

      <template v-slot:uploadFile="{file, remove}">
        {{ file.name }}
        {{ file.size }}
        <button type="button" @click.prevent="remove(file)" :key="file.id">취소</button>
      </template>

      <template v-slot:selectButton>
        <button type="button">업로드파일선택</button>
      </template>

    </i-fileupload>

    <!-- <i-fileupload
      v-model="file2"
      ref="file2"
      @done="uploadOk"
      kind="vie_free">

      <button type="button">업로드파일선택2</button>
    </i-fileupload> -->
<br/>
<br/>
    <button type=button @click.prevent="doSubmit">등록</button>
</div>
</template>


<script>
export default {
  data() {
    return {
      file1: {name: 'xxx'},
      file2: {name: 'xxx'},
      sitem: {
        name: '홍길동',
        fileId: ''
      }
    }
  },

  methods: {
    doSubmit() {
      this.$refs.file1.start(this.doSubmitReal)

    },
    doSubmitReal() {
      console.log("file1 = ", JSON.stringify(this.file1))
      alert("실제 업로드!");
    },
  },
}
</script>